/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const generateCampaignImageSchema = z.object({
	campaignId: z.string().uuid(),
	additionalInstructions: z.string(),
})

export type GenerateCampaignImageSchema = z.infer<typeof generateCampaignImageSchema>
